import { useSelector } from 'react-redux'
import { formatByTheme } from '../../../helpers/theme'
import { selectChartData } from '../store'

export const TooltipCursor = (props) => {
  const { points, chartId } = props

  const { activeTooltip } = useSelector(selectChartData(chartId))

  if ((chartId && !activeTooltip) || !points) return null

  return (
    <line
      x1={points[0].x}
      y1={points[0].y}
      x2={points[1].x}
      y2={points[1].y}
      stroke={formatByTheme('#555555')}
      strokeDasharray="3 3"
      pointerEvents="none"
    />
  )
}
